import { render } from "./SettingsEnvironment.vue?vue&type=template&id=00f94ddc&scoped=true"
import script from "./SettingsEnvironment.vue?vue&type=script&lang=js"
export * from "./SettingsEnvironment.vue?vue&type=script&lang=js"

import "./SettingsEnvironment.vue?vue&type=style&index=0&id=00f94ddc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f94ddc"]])

export default __exports__